import { privateAxios, publicAxios } from "@src/axios.config";

export const handleTermsAndConditions = async (request = "GET", text = "") => {
  const path = "/api/terms-and-conditions";
  if (request === "POST" && text !== "") {
    return await privateAxios.post(path, { text });
  } else {
    return await publicAxios.get(path);
  }
};

export const handlePrivacyStatement = async (request = "GET", text = "") => {
  const path = "/api/privacy-policy";
  if (request === "POST" && text !== "") {
    return await privateAxios.post(path, { text });
  } else {
    return await publicAxios.get(path);
  }
};

export const contactCraftPositions = async (values) => {
  return await publicAxios.post("/api/contact-us", values);
};

export const subscribeNewsletter = async (email = "") => {
  return await publicAxios.post("/api/subscriptions", { email });
};

export const sendNewsletter = async (values) => {
  return await privateAxios.post("/api/send-newsletter", values);
};

export const uploadFile = async (file = "") => {
  const formData = new FormData();
  formData.append("file", file);

  return await privateAxios.post("/api/upload", formData);
};

export const GetSkills = async () => {
  return await privateAxios.get(`/api/skill-suggestions`);
};

export const UpdateSkillsArray = async (skills) => {
  return await privateAxios.post("/api/skill-suggestions", skills);
};

export const GetCompanyTypeSuggestions = async () => {
  return await privateAxios.get(`/api/company-type-suggestions`);
};

export const UpdateCompanyTypeSuggestions = async (companyTypes) => {
  return await privateAxios.post("/api/company-type-suggestions", companyTypes);
};

export const GetJobPositionSuggestions = async () => {
  return await privateAxios.get(`/api/job-position-suggestions`);
};

export const UpdateJobPositionSuggestions = async (jobPositions) => {
  return await privateAxios.post("/api/job-position-suggestions", jobPositions);
};

export const GetDepartmentSuggestions = async () => {
  return await privateAxios.get(`/api/department-suggestions`);
};

export const UpdateDepartmentSuggestions = async (departments) => {
  return await privateAxios.post("/api/department-suggestions", departments);
};

export const GetDegreeNameSuggestions = async () => {
  return await privateAxios.get(`/api/degree-name-suggestions`);
};

export const UpdateDegreeNameSuggestions = async (degreeNames) => {
  return await privateAxios.post("/api/degree-name-suggestions", degreeNames);
};

/** Per-user degree names (candidate resume); does not add to global degree-name-suggestions. */
export const GetMyDegreeNameSuggestions = async () => {
  return await privateAxios.get(`/api/my-degree-name-suggestions`);
};

export const UpdateMyDegreeNameSuggestions = async (degreeNames) => {
  return await privateAxios.post("/api/my-degree-name-suggestions", degreeNames);
};

export const CheckSitePassword = async (password = "") => {
  return await publicAxios.post(`/api/verify-frontend-password`, { password });
};

export const SearchCompany = async (company_name = "", abortController) => {
  return await privateAxios.get(`/api/company/search`, {
    params: { search: company_name },
    signal: abortController.signal,
  });
};

/** @param {number[]} employerProfileIds */
export const GetCompanyNamesByIds = async (employerProfileIds = []) => {
  const ids = (employerProfileIds || [])
    .map((x) => Number(x))
    .filter((n) => !Number.isNaN(n));
  if (!ids.length) {
    return { data: { results: [] } };
  }
  return await privateAxios.get(`/api/company/names-by-ids`, {
    params: { ids: ids.join(",") },
  });
};

export const SendEnrollRequest = async (employerId, workEmail) => {
  return await privateAxios.post(`/api/enrollments/request`, {
    employer: employerId,
    work_email: workEmail?.trim() || "",
  });
};

export const EnrollmentRequests = async () => {
  return await privateAxios.get(`/api/enrollments/pending`);
};

export const EnrollmentStatusUpdate = async (id, status) => {
  return await privateAxios.put(`/api/enrollments/${id}`, {
    status,
  });
};

export const DeleteEnrollment = async (id) => {
  return await privateAxios.delete(`/api/enrollments/${id}`);
}

export const FinalizedEnrollments = async () => {
  return await privateAxios.get("/api/enrollments/finalized");
};

export const EnrolledCompanies = async () => {
  return await privateAxios.get("/api/users/me/company");
};

export const EnrolledCompanyCandidates = async () => {
  return await privateAxios.get("/api/users/me/company/candidates");
};

export const GetCandidateEnrollmentRequests = async () => {
  return await privateAxios.get("/api/enrollments/my-requests");
};

// Promoting Platform APIs
export const getPromotingPlatforms = async () => {
  return await publicAxios.get("/api/promoting/");
};

export const createPromotingPlatform = async (data) => {
  return await privateAxios.post("/api/promoting/", data);
};

export const updatePromotingPlatform = async (id, data) => {
  return await privateAxios.put(`/api/promoting/${id}/`, data);
};

export const deletePromotingPlatform = async (id) => {
  return await privateAxios.delete(`/api/promoting/${id}/`);
};
